import { Pipe, PipeTransform } from '@angular/core';
import { FirestoreService } from '../services/firestore.service';
import { DocumentReference } from '@angular/fire/firestore';

@Pipe({ name: 'firestoreDoc$' })
export class FirestoreDocPipe implements PipeTransform {

  constructor(private db: FirestoreService) {}

  async transform(ref: DocumentReference) {
    return ref instanceof DocumentReference ? await this.db.docSnap(ref.path) : null;
  }

}
